const SvgIconCaretUpFilled = (props) => (
  <svg viewBox="0 0 10 5" fill="none" {...props}>
    <path d="M10 5L5 0 0 5h10z" fill="currentColor" />
  </svg>
)

export default SvgIconCaretUpFilled
